export default __webpack_public_path__ + "static/media/auman_4.0cc61453.png";